class ProductCardKit extends HTMLElement {
  constructor() {
    super();
    this.moreColors = this.querySelector('[data-kit-more-colors]')
    this.hasMoreColors = 0;
    this.init();
  }

  init() {
    this.buildKit();
  }

  async buildKit() {
    let groups = this.dataset.groups
    groups = groups.split(",");

    let uniqueGroups = [...new Set(groups)];
    let kitQuery = `{`
    for (const [i, tag] of uniqueGroups.entries()) {
      kitQuery += `group${i}: products(query: "tag:'${tag}'", first: 20, sortKey: TITLE) {
        edges{
          node{
            ...productDetails
          }
        }
      }`;
    }
    kitQuery += `}
    fragment productDetails on Product {
      title
      handle
      id
      exclude: metafield(namespace: "c_f", key: "exclude_colors_for_online") {
        value
      }
      badge: metafield(namespace: "custom_fields", key: "merchandising_message_tag") {
        value
      }
      media(first: 1) {
        edges {
          node {
            alt
            mediaContentType
            previewImage {
              url
            }
          }
        }
      }
      variants(first: 20) {
        edges {
          node {
            availableForSale
            quantityAvailable
            price {
              amount
            }
            compareAtPrice {
              amount
            }
            title
            id
            sku
          }
        }
      }
    }`

    const response = await this.getData(kitQuery);
    Object.entries(response.data).forEach(([key, value], index) => {
      this.buildColorOptions(value.edges, index);
    })
  }

  getData(kitQuery) {
    return fetch(window.api_url, {
        method: 'POST',
        'crossDomain': true,
        headers: {
          'X-Shopify-Storefront-Access-Token': window.api_key,
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          query: kitQuery
        })
      })
      .then((response) => response.json())

  }

  buildColorOptions(data) {
    let childColorProducts = 0
    for (var i = 0; i < data.length; i++) {
      let product = data[i].node;
      var title = product.media.edges[0]?.node?.alt;
      title = title.substring(title.indexOf('#') + 1).trim();
      if (product.exclude != null) {
        if (product.exclude.value.includes(title)) {
          continue;
        }
      }
      childColorProducts++;
    }
    console.log(childColorProducts)

    if (childColorProducts > 1 && !this.hasMoreColors) {
      this.hasMoreColors = true
      this.moreColors && this.moreColors.classList.remove('hide')
    }
  }

}

if (!customElements.get("product-card-kit")) {
  customElements.define("product-card-kit", ProductCardKit);
}